module.exports = __webpack_public_path__ + "static/media/adey-bennett-photo-2.0c6d471a.jpg";